import { motion } from "framer-motion";
import LazyLoad from "../../../Image/LazyLoad";
import { RegularIcon } from "../../../Icons/regular";
import { LightIcon } from "../../../Icons/light";

const Video = ({ asset, addVideoRefs, i }) => {
	return (
		<video ref={el => { addVideoRefs(el, i) }} width={`100%`} height={`100%`} controls>
			<source src={`${asset.video.url}`} type="video/mp4" />
			Your browser does not support the video tag.
		</video>
	);
}

const IframeEmbed = ({ asset, addVideoRefs }) => {
	var video_id = asset.video.url.split("v=")[1];
	var ampersandPosition = video_id.indexOf("&");

	if (ampersandPosition != -1) {
		video_id = video_id.substring(0, ampersandPosition);
	}

	if (!video_id) {
		return null;
	}

	return (
		<iframe
			ref={addVideoRefs}
			className="youtubeVideo"
			width="1377"
			height="775"
			src={`https://www.youtube.com/embed/${video_id}?rel=0&showinfo=0&controls=0&modestbranding=0`}
			frameBorder="0"
			allowFullScreen="allowfullscreen"
		/>
	);
};

const open = {
	open: { width: "100%", opacity: 1 },
	closed: { width: 0, opacity: 0 },
};

const slideVariants = {
	appear: {
		x: "0",
		transition: {
			type: "tween",
			duration: 0.15,
			ease: "easeIn",
			from: "50%",
		},
	},
	disappear: {
		x: "100%",
		transition: { from: "50%", type: "tween", duration: 0.15, ease: "easeOut" },
	},
	enterRight: {
		x: "0",
		transition: {
			type: "tween",
			duration: 0.30,
			ease: "easeIn",
			from: "100%",
		},
	},
	exitRight: {
		x: "100%",
		transition: { type: "tween", duration: 0.5, ease: "easeOut" },
	},
	enterLeft: {
		x: "0",
		transition: {
			type: "tween",
			duration: 0.30,
			ease: "easeIn",
			from: "-100%",
		},
	},
	exitLeft: {
		x: "-100%",
		transition: { type: "tween", duration: 0.5, ease: "easeOut" },
	},
};

const getPose = (i, activeIndex, prevIndex, openGallery, triggerSource) => {

	if (triggerSource === 'thumbnail') {
		if (i === activeIndex) {
			return "appear";
		} else {
			return "disappear";
		}
	} else if (i === activeIndex) {
		if (prevIndex < activeIndex) {
			return "enterRight";
		} else {
			return "enterLeft";
		}
	} else if (i === prevIndex) {
		if (prevIndex < activeIndex) {
			return "exitLeft";
		} else {
			return "exitRight";
		}
	}

	return false;
};

const FullscreenGallery = ({
	openGallery,
	setOpenGallery,
	block,
	prevImage,
	nextImage,
	addVideoRefs,
	activeIndex,
	toggleScroll,
	prevIndex,
	triggerSource
}) => {
	return (
		<motion.div
			animate={openGallery ? "open" : "closed"}
			initial="closed"
			variants={open}
			className="galleryCarousel"
			transition={{ duration: 0.15, type: "tween", ease: [0.17, 0.67, 0.83, 0.67] }}
		>
			{block.data.children.map((child, i) => {
				const animType = getPose(i, activeIndex, prevIndex, openGallery, triggerSource);
				const stateClass = ` ${i === activeIndex ? 'active' : i === prevIndex ? 'prev' : ''}`;

				const asset = child.data;

				if (asset['image']) {
					return (
						<motion.div
							id={i}
							className={`asset${stateClass}`}
							animate={animType}
							variants={slideVariants}
							data-size={asset.size}
							key={i}
						>
							<LazyLoad image={asset.image} />
						</motion.div>
					);
				} else {
					return (
						<motion.div
							id={i}
							className={`asset${stateClass}`}
							animate={animType}
							variants={slideVariants}
							data-size={asset.size}
							key={i}
						>
							{asset.video.kind == "video" ? (
								<Video asset={asset} addVideoRefs={addVideoRefs} i={i} />
							) : (
								<IframeEmbed asset={asset} addVideoRefs={addVideoRefs} />
							)}
						</motion.div>
					);
				}
			})}
			<div className="close">
				<RegularIcon
					icon={{
						icon: "times", type: "far",
						size: "2x",
					}}
					onClick={() => {
						setOpenGallery(false);
						toggleScroll(true);
					}}
				/>
			</div>
			{activeIndex > 0 && (
				<div className="navArrow leftArrow" onClick={prevImage}>
					<LightIcon
						icon={{ type: "fal", icon: "angle-left", size: "3x" }}
					/>
				</div>
			)}
			{activeIndex < (block.data.children.length - 1) && (
				<div className="navArrow rightArrow" onClick={nextImage}>
					<LightIcon
						icon={{ type: "fal", icon: "angle-right", size: "3x" }}
					/>
				</div>
			)}
		</motion.div>
	);
}

export default FullscreenGallery;